module.exports = __webpack_public_path__ + "img/left-arrow.ae21709e.svg";